import { debounce } from 'lodash';
import React from 'react';
import InputNumber from '../input-number';
import Popover from '../popover';
import Tooltip from '../tooltip';
import './index.less';

interface IInputNumberProps {
    value: number;
    maxVal: number;
    minVal: number;
    width?: number;
    height?: number;
    onChange?: (value: number | null) => void;
    onAfterChange?: (value: number | null) => void;
    onOpenChange?: (open: boolean) => void;

    // 显示 上下箭头调节器
    showStepBtn?: boolean;
    // 鼠标hover提示
    tip?: string;
    inputContent?: React.ReactNode;
    disableMouseWheel?: boolean;
    // 小数点位数
    decimalPoint?: number;

    disabled?: boolean;

    autoSelect?: boolean;

    addonAfter?: React.ReactNode;

    addonBefore?: React.ReactNode;
    trigger?: 'click' | 'hover';
}

const ComInputNumber = ({
    value,
    maxVal,
    minVal,
    width,
    height,
    onChange,
    onAfterChange,
    onOpenChange,
    showStepBtn,
    tip,
    inputContent,
    decimalPoint,
    disabled = false,
    disableMouseWheel = false,
    // autoSelect = true,
    addonAfter,
    addonBefore,
    trigger = 'hover',
}: IInputNumberProps) => {
    const handleVal = (num: number) => {
        // 取区间值
        let val = Math.min(num, maxVal);
        val = Math.max(val, minVal);
        return val;
    };

    const handleOnInput = debounce((newVal: string) => {
        let num = +newVal;

        if (isNaN(num)) {
            num = value;
        }

        let result = handleVal(num);
        if (result < minVal) {
            result = minVal;
        }

        if (decimalPoint === undefined) {
            onChange?.(result);
        } else {
            const val = handleVal(+num.toFixed(decimalPoint || 0));
            onChange?.(val);
        }
    }, 500);

    const inputEle = () => {
        return (
            <div
                className="app-input-number"
                style={{
                    width: width || 90,
                    height: height || 34,
                }}
            >
                <InputNumber
                    value={value}
                    max={maxVal}
                    min={minVal}
                    bordered={false}
                    stringMode
                    showStepBtn={showStepBtn}
                    addonBefore={addonBefore}
                    addonAfter={addonAfter}
                    disabled={disabled}
                    className="m-input-container"
                    onInput={handleOnInput}
                    onChange={onChange}
                    onChangeAfter={onAfterChange}
                    enableMouseWheel={!disableMouseWheel}
                />
            </div>
        );
    };

    return (
        <Tooltip title={tip || ''}>
            {inputContent ? (
                <Popover
                    content={inputContent}
                    placement="bottom"
                    overlayClassName="app-font-size-list"
                    trigger={trigger}
                    onOpenChange={onOpenChange}
                >
                    {inputEle()}
                </Popover>
            ) : (
                inputEle()
            )}
        </Tooltip>
    );
};

export default ComInputNumber;
